window.addEventListener('load', () => {
  let moredetailButtonMouseHover = {
    setup: function(event) {
      event.target.classList.add('is-hover');
      event.target.classList.remove('animation-step5');
      event.target.classList.add('animation-step1');
      this.animationStepTimer1 = setTimeout(function(){
        event.target.classList.remove('animation-step1');
        event.target.classList.add('animation-step2');
      }, 200);
      this.animationStepTimer2 = setTimeout(function(){
        event.target.classList.remove('animation-step2');
        event.target.classList.add('animation-step3');
      }, 400);
      this.animationStepTimer3 = setTimeout(function(){
        event.target.classList.remove('animation-step3');
        event.target.classList.add('animation-step4');
      }, 600);
    },

    cancel: function(event) {
      event.target.classList.remove('is-hover', 'animation-step1', 'animation-step2', 'animation-step3', 'animation-step4');
      window.clearTimeout(this.animationStepTimer1);
      window.clearTimeout(this.animationStepTimer2);
      window.clearTimeout(this.animationStepTimer3);
      event.target.classList.add('animation-step5');
    }
  };

  const moredetailButtonElements = document.querySelectorAll('.MoredetailButton');
  if (moredetailButtonElements) {
    for (let i = 0; i < moredetailButtonElements.length; i++) {
      moredetailButtonElements[i].addEventListener("mouseenter", moredetailButtonMouseHover.setup);
      moredetailButtonElements[i].addEventListener("mouseleave", moredetailButtonMouseHover.cancel);
    }
  }
});